<template>
  <div id="partner" :style="{ backgroundColor: '#f7f8f9' }">
    <div class="inner">
      <div class="top">
        <div class="top_box_l">
          <div
            class="top_title"
            :style="{
              fontSize: ['zh_CN', 'zh_HK'].includes($i18n.locale)
                ? '1.2rem'
                : '1.3rem',
              height: ['zh_CN', 'zh_HK'].includes($i18n.locale)
                ? '2.20833vw'
                : '5.20833vw',
            }"
          >
            {{ $t("home_partner_title") }}
          </div>
          <div class="top_desc_title">
            {{ $t("home_partner_contact_title") }}
          </div>
          <div class="top_desc">
            {{ $t("home_partner_contact_desc") }}
          </div>
        </div>
        <div class="top_tabs" :style="{ backgroundColor: '#ffffff' }">
          <div class="top_tabs_t">
            <div
              class="tab-item"
              :class="activeTab === 0 ? 'tab-active' : 'tab-inactive'"
              @click="tabClick(0)"
            >
              {{ $t("home_partner_tab_agent") }}
            </div>
            <div
              class="tab-item"
              :class="activeTab === 1 ? 'tab-active' : 'tab-inactive'"
              @click="tabClick(1)"
            >
              {{ $t("home_partner_tab_partner") }}
            </div>
          </div>
          <div class="top_content">
            <!-- 商家 tab：按设计稿改造，每个字段带标题+必填星号 -->
            <div class="top_content_r" v-if="activeTab === 0">
              <div class="form-item form-item-name">
                <div class="form-label">
                  <span>
                    {{ $t("home_partner_label_name") }}
                  </span>
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    :class="{ 'div_input-error': nameError }"
                    type="text"
                    :value="name"
                    :placeholder="$t('home_partner_placeholder_name')"
                    @input="onInput('name', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div class="field-error" v-if="nameError">
                    {{ $t(nameError) }}
                  </div>
                </div>
              </div>

              <div class="form-item form-item-contact">
                <div class="form-label">
                  {{ $t("home_partner_label_contact") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <div class="contact-type-radio">
                    <div
                      class="radio-option"
                      @click="selectContactType('phone')"
                    >
                      <span
                        class="radio-dot"
                        :class="{ 'radio-dot-active': contactType === 'phone' }"
                      ></span>
                      <span>{{ $t("home_partner_contact_type_phone") }}</span>
                    </div>
                    <div
                      class="radio-option"
                      @click="selectContactType('email')"
                    >
                      <span
                        class="radio-dot"
                        :class="{ 'radio-dot-active': contactType === 'email' }"
                      ></span>
                      <span>{{ $t("home_partner_contact_type_email") }}</span>
                    </div>
                  </div>
                  <PhoneInput
                    v-if="contactType === 'phone'"
                    :value="mobile"
                    :prefix="phonePrefix"
                    :prefix-list="phonePrefixList"
                    :clear-trigger="phoneInputClearKey"
                    :dropdown-visible="phonePrefixDropdown"
                    :has-error="!!contactError"
                    @toggle-dropdown="togglePhonePrefixDropdown"
                    @select-prefix="selectPhonePrefix"
                    @mobile="onInput('mobile', $event)"
                    @blur="onBlurMobile($event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <input
                    v-else
                    class="div_input"
                    :class="{ 'div_input-error': emailError || contactError }"
                    type="text"
                    inputmode="email"
                    :value="mail"
                    :placeholder="$t('home_partner_placeholder_email')"
                    @input="onInputEmail($event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div
                    class="field-error"
                    v-if="contactType === 'email' && emailError"
                  >
                    {{ $t(emailError) }}
                  </div>
                  <div class="field-error" v-if="contactError">
                    {{ $t(contactError) }}
                  </div>
                </div>
              </div>

              <div class="form-item">
                <div class="form-label form-label-multiline">
                  <span>{{ whatsappLabelLine1 }}</span>
                  <span>{{ whatsappLabelLine2 }}</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    type="text"
                    :value="whatsApp"
                    :placeholder="$t('home_partner_placeholder_whatsapp')"
                    @input="onInput('whatsApp', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                </div>
              </div>

              <div class="form-item">
                <div class="form-label">
                  {{ $t("home_partner_label_store_count") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    :class="{ 'div_input-error': storeCountError }"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    :value="storeCount"
                    :placeholder="$t('home_partner_input_store_count')"
                    @input="onInputStoreCount($event)"
                    @blur="onBlurStoreCount($event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div class="field-error" v-if="storeCountError">
                    {{ $t(storeCountError) }}
                  </div>
                </div>
              </div>

              <div class="form-item">
                <div class="form-label">
                  {{ $t("home_partner_label_store_name") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    :class="{ 'div_input-error': storeNameError }"
                    type="text"
                    :value="storeName"
                    :placeholder="$t('home_partner_placeholder_store_name')"
                    @input="onInput('storeName', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div class="field-error" v-if="storeNameError">
                    {{ $t(storeNameError) }}
                  </div>
                </div>
              </div>

              <div class="form-item">
                <div class="form-label">
                  {{ $t("home_partner_label_store_location") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <div
                    class="select-control"
                    :class="{
                      'select-control-open': locationDropdown,
                      'select-control-error': locationError,
                    }"
                    @click="toggleLocationDropdown"
                  >
                    <span :class="{ placeholder: !location }">{{
                      location
                        ? location.label
                        : $t("home_partner_placeholder_store_location")
                    }}</span>
                    <span class="select-arrow">
                      <img :src="locationDropdown ? upIcon : downIcon" alt="" />
                    </span>
                    <ul v-if="locationDropdown" class="select-options">
                      <li
                        v-for="item in locationOptions"
                        :key="item.value"
                        :class="{
                          active: location && item.value === location.value,
                        }"
                        @click.stop="selectLocation(item)"
                      >
                        {{ item.label }}
                      </li>
                    </ul>
                  </div>
                  <div class="field-error" v-if="locationError">
                    {{ $t(locationError) }}
                  </div>
                </div>
              </div>

              <div class="form-item">
                <div class="form-label">
                  {{ $t("home_partner_label_store_type") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <div
                    class="select-control"
                    :class="{
                      'select-control-open': storeTypeDropdown,
                      'select-control-error': storeTypeError,
                    }"
                    @click="toggleStoreTypeDropdown"
                  >
                    <span :class="{ placeholder: !storeType }">{{
                      storeType
                        ? storeType.label
                        : $t("home_partner_placeholder_store_type")
                    }}</span>
                    <span class="select-arrow">
                      <img :src="storeTypeDropdown ? upIcon : downIcon" alt="" />
                    </span>
                    <ul v-if="storeTypeDropdown" class="select-options">
                      <li
                        v-for="item in storeTypeOptions"
                        :key="item.value"
                        :class="{
                          active: storeType && item.value === storeType.value,
                        }"
                        @click.stop="selectStoreType(item)"
                      >
                        {{ item.label }}
                      </li>
                    </ul>
                  </div>
                  <div class="field-error" v-if="storeTypeError">
                    {{ $t(storeTypeError) }}
                  </div>
                </div>
              </div>

              <div class="button" @click="submit">
                {{ $t("home_partner_submit") }}
              </div>
            </div>

            <!-- 合作商 tab：按设计稿改造，每个字段带标题+必填星号 -->
            <div class="top_content_r" v-else>
              <div class="form-item form-item-name">
                <div class="form-label">
                  <span>
                    {{ $t("home_partner_label_name") }}
                  </span>
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    :class="{ 'div_input-error': nameError }"
                    type="text"
                    :value="name"
                    :placeholder="$t('home_partner_placeholder_name')"
                    @input="onInput('name', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div class="field-error" v-if="nameError">
                    {{ $t(nameError) }}
                  </div>
                </div>
              </div>

              <div class="form-item form-item-contact">
                <div class="form-label">
                  {{ $t("home_partner_label_contact") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <div class="contact-type-radio">
                    <div
                      class="radio-option"
                      @click="selectContactType('phone')"
                    >
                      <span
                        class="radio-dot"
                        :class="{ 'radio-dot-active': contactType === 'phone' }"
                      ></span>
                      <span>{{ $t("home_partner_contact_type_phone") }}</span>
                    </div>
                    <div
                      class="radio-option"
                      @click="selectContactType('email')"
                    >
                      <span
                        class="radio-dot"
                        :class="{ 'radio-dot-active': contactType === 'email' }"
                      ></span>
                      <span>{{ $t("home_partner_contact_type_email") }}</span>
                    </div>
                  </div>
                  <PhoneInput
                    v-if="contactType === 'phone'"
                    :value="mobile"
                    :prefix="phonePrefix"
                    :prefix-list="phonePrefixList"
                    :clear-trigger="phoneInputClearKey"
                    :dropdown-visible="phonePrefixDropdown"
                    :has-error="!!contactError"
                    @toggle-dropdown="togglePhonePrefixDropdown"
                    @select-prefix="selectPhonePrefix"
                    @mobile="onInput('mobile', $event)"
                    @blur="onBlurMobile($event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <input
                    v-else
                    class="div_input"
                    :class="{ 'div_input-error': emailError || contactError }"
                    type="text"
                    inputmode="email"
                    :value="mail"
                    :placeholder="$t('home_partner_placeholder_email')"
                    @input="onInputEmail($event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div
                    class="field-error"
                    v-if="contactType === 'email' && emailError"
                  >
                    {{ $t(emailError) }}
                  </div>
                  <div class="field-error" v-if="contactError">
                    {{ $t(contactError) }}
                  </div>
                </div>
              </div>

              <div class="form-item">
                <div class="form-label form-label-multiline">
                  <span>{{ whatsappLabelLine1 }}</span>
                  <span>{{ whatsappLabelLine2 }}</span>
                </div>
                <div class="form-control">
                  <input
                    class="div_input"
                    type="text"
                    :value="whatsApp"
                    :placeholder="$t('home_partner_placeholder_whatsapp')"
                    @input="onInput('whatsApp', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                </div>
              </div>

              <div class="form-item form-item-contact form-item-budget">
                <div class="form-label">
                  {{ $t("home_partner_label_budget") }}
                  <span class="required">*</span>
                </div>
                <div class="form-control">
                  <div class="budget-radio">
                    <div
                      class="radio-option"
                      v-for="item in budgetOptions"
                      :key="item.id"
                      @click="selectBudget(item)"
                    >
                      <span
                        class="radio-dot"
                        :class="{
                          'radio-dot-active': budget && budget.id === item.id,
                        }"
                      ></span>
                      <span class="radio-label">{{ item.label }}</span>
                    </div>
                  </div>
                  <div class="field-error" v-if="budgetError">
                    {{ $t(budgetError) }}
                  </div>
                </div>
              </div>

              <div class="button" @click="submit">
                {{ $t("home_partner_submit") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryByDomain } from "@/common/config";
import PhoneInput from "./PhoneInput.vue";
import { getClientTag } from "@/utils/index";
import downIcon from "@/assets/Keeta2/select-down.png";
import upIcon from "@/assets/Keeta2/select-up.png";

export default {
  name: "PartnerView",
  components: {
    PhoneInput,
  },
  data() {
    return {
      downIcon,
      upIcon,
      activeTab: 0,
      name: "",
      mail: "",
      mobile: "",
      whatsApp: "",
      budget: null,
      storeName: "",
      location: null,
      storeType: null,
      storeCount: "",
      contactType: "phone",
      phonePrefixList: [],
      phonePrefix: "+852",
      phonePrefixDropdown: false,
      phoneRegionCode: "",
      emailError: "",
      storeCountError: "",
      phoneInputClearKey: 0,
      // 各必填字段的校验错误提示，点击提交后按字段展示在输入框下方
      nameError: "",
      contactError: "",
      storeNameError: "",
      locationError: "",
      storeTypeError: "",
      budgetError: "",
      // 店铺位置下拉选择，选项数据来自 queryProspectiveParentRegionOptions
      locationOptions: [],
      locationDropdown: false,
      // 店铺类型下拉选择，选项数据来自 queryProspectivePartnerStoreType
      storeTypeOptions: [],
      storeTypeDropdown: false,
      // 投资预算单选，选项数据来自 queryBudgetOptions
      budgetOptions: [],
    };
  },
  created() {
    this.fetchPartnerOptions();
  },
  watch: {
    "$i18n.locale"() {
      this.locationDropdown = false;
      this.storeTypeDropdown = false;
      this.phonePrefixDropdown = false;
      this.fetchPartnerOptions();
    },
  },
  methods: {
    onMouseLeave(event) {
      event.target.blur(); // 鼠标离开时让输入框失去焦点
    },
    tabClick(tabIndex) {
      this.activeTab = tabIndex;
      this.name = "";
      this.mail = "";
      this.mobile = "";
      this.whatsApp = "";
      this.budget = null;
      this.storeName = "";
      this.location = null;
      this.storeType = null;
      this.storeCount = "";
      this.storeCountError = "";
      this.contactType = "phone";
      this.locationDropdown = false;
      this.storeTypeDropdown = false;
      this.phonePrefixDropdown = false;
      this.clearFieldErrors();
    },
    clearForm() {
      this.name = "";
      this.mail = "";
      this.mobile = "";
      this.whatsApp = "";
      this.budget = null;
      this.storeName = "";
      this.location = null;
      this.storeType = null;
      this.storeCount = "";
      this.storeCountError = "";
      this.contactType = "phone";
      this.locationDropdown = false;
      this.storeTypeDropdown = false;
      this.phonePrefixDropdown = false;
      this.phoneInputClearKey++;
      this.clearFieldErrors();
    },
    togglePhonePrefixDropdown() {
      this.phonePrefixDropdown = !this.phonePrefixDropdown;
    },
    selectPhonePrefix(prefixObj) {
      this.phonePrefix = "+" + prefixObj.code;
      this.phonePrefixDropdown = false;
    },
    selectBudget(item) {
      this.budget = item;
      this.budgetError = "";
    },
    selectContactType(type) {
      this.contactType = type;
      this.contactError = "";
      // 切换联系方式时清空另一种方式已填写的内容，避免误提交
      if (type === "phone") {
        this.mail = "";
        this.emailError = "";
      } else {
        this.mobile = "";
        this.phoneRegionCode = "";
        this.phoneInputClearKey++;
      }
    },
    toggleLocationDropdown() {
      this.locationDropdown = !this.locationDropdown;
    },
    selectLocation(item) {
      this.location = item;
      this.locationDropdown = false;
      this.locationError = "";
    },
    toggleStoreTypeDropdown() {
      this.storeTypeDropdown = !this.storeTypeDropdown;
    },
    selectStoreType(item) {
      this.storeType = item;
      this.storeTypeDropdown = false;
      this.storeTypeError = "";
    },
    onInput(field, value) {
      if (field === "mobile" && typeof value === "object") {
        this.mobile = value.mobile;
        this.phoneRegionCode = value.regionCode;
        if (this.mobile) this.contactError = "";
      } else {
        this[field] =
          typeof value === "string"
            ? value.trim()
            : (value?.target?.value ?? "").trim();
        if (field === "name" && this.name) this.nameError = "";
        if (field === "storeName" && this.storeName) this.storeNameError = "";
      }
    },
    // 各区号对应的手机号位数：大陆11位 / 香港8位 / 澳门8位
    getMobileLengthByPrefix(prefix) {
      const lengthMap = {
        "+86": 11,
        "+852": 8,
        "+853": 8,
      };
      return lengthMap[prefix];
    },
    // 手机号失焦校验：仅在有内容时按区号校验位数，是否必填由提交时统一校验
    onBlurMobile({ mobile, regionCode }) {
      const val = (mobile || "").trim();
      if (!val) return;
      const requiredLength = this.getMobileLengthByPrefix(regionCode);
      const isValid = requiredLength ? val.length === requiredLength : true;
      this.contactError = isValid ? "" : "home_partner_phone_error";
    },
    onInputEmail(event) {
      const val = event.target.value.trim();
      this.mail = val;
      if (!val) {
        // 邮箱为空时留到提交时统一按“必填”提示，不在此处报格式错误
        this.emailError = "";
        return;
      }
      this.contactError = "";
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailReg.test(val);
      this.emailError = isValid ? "" : "home_partner_email_error";
    },
    onInputStoreCount(event) {
      const rawVal = event.target.value;
      const trimmedRaw = rawVal.trim();
      // 仅保留数字字符（正整数）
      const digitsOnly = trimmedRaw.replace(/[^\d]/g, "");
      // 若因过滤丢弃了非法字符，同步更新可视内容，避免非数字字符残留在输入框中
      if (digitsOnly !== rawVal) {
        event.target.value = digitsOnly;
        event.target.setSelectionRange(digitsOnly.length, digitsOnly.length);
      }
      this.storeCount = digitsOnly;
      // 输入过程中：曾输入过内容但过滤后为空（即输入的是特殊符号），立即提示无效；
      // 输入框本身为空（用户还未输入或已清空）则不报错，留到提交时再校验必填
      if (trimmedRaw !== "" && digitsOnly === "") {
        this.storeCountError = "home_partner_store_count_invalid";
      } else {
        this.storeCountError = this.validateStoreCount(digitsOnly, {
          allowEmpty: true,
        });
      }
    },
    // 失焦时校验：必填，只允许正整数，超过上限提示
    onBlurStoreCount() {
      this.storeCountError = this.validateStoreCount(this.storeCount);
    },
    // allowEmpty为true时，空值不报错（用于输入过程中），提交时会再统一校验必填
    validateStoreCount(value, { allowEmpty = false } = {}) {
      if (value === "" || value === undefined || value === null) {
        return allowEmpty ? "" : "home_partner_store_count_invalid";
      }
      const num = Number(value);
      if (!Number.isInteger(num) || num < 1) {
        return "home_partner_store_count_invalid";
      }
      if (num > 9999) {
        return "home_partner_store_count_max";
      }
      return "";
    },
    clearFieldErrors() {
      this.nameError = "";
      this.contactError = "";
      this.emailError = "";
      this.storeCountError = "";
      this.storeNameError = "";
      this.locationError = "";
      this.storeTypeError = "";
      this.budgetError = "";
    },
    // 联系方式为单选（电话或邮箱二选一），只校验当前选中的方式：
    // 电话方式下未填写时提示"请输入您的电话"；邮箱方式下未填写时提示"请输入您的邮箱"，
    // 邮箱方式下已填写但格式错误时提示邮箱格式错误
    checkContactValid() {
      if (this.contactType === "phone") {
        const val = this.mobile.trim();
        if (!val) {
          this.contactError = "home_partner_error_input_phone";
          return false;
        }
        const requiredLength = this.getMobileLengthByPrefix(
          this.phoneRegionCode
        );
        const valid = requiredLength ? val.length === requiredLength : true;
        this.contactError = valid ? "" : "home_partner_phone_error";
        return valid;
      }
      const mailVal = this.mail.trim();
      if (!mailVal) {
        this.contactError = "home_partner_error_input_email";
        this.emailError = "";
        return false;
      }
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailReg.test(mailVal);
      this.contactError = "";
      this.emailError = isValid ? "" : "home_partner_email_error";
      return isValid;
    },
    async submit() {
      this.clearFieldErrors();
      let isValid = true;

      if (!this.name.trim()) {
        this.nameError = "home_partner_error_name";
        isValid = false;
      }
      if (!this.checkContactValid()) {
        isValid = false;
      }

      // 商家tab必填项校验：门店数量、店铺名称、店铺位置、店铺类型
      if (this.activeTab === 0) {
        this.storeCountError = this.validateStoreCount(this.storeCount);
        if (this.storeCountError) isValid = false;
        if (!this.storeName.trim()) {
          this.storeNameError = "home_partner_error_store_name";
          isValid = false;
        }
        if (!this.location) {
          this.locationError = "home_partner_error_select_store_location";
          isValid = false;
        }
        if (!this.storeType) {
          this.storeTypeError = "home_partner_error_select_store_type";
          isValid = false;
        }
      }
      // 合作商tab必填项校验：投资预算
      if (this.activeTab === 1) {
        if (!this.budget) {
          this.budgetError = "home_partner_error_select_budget";
          isValid = false;
        }
      }

      if (!isValid) return;
      const params = {
        name: this.name,
        mail: this.mail,
        mobile: this.mobile,
        whatsApp: this.whatsApp,
        budget: this.budget ? this.budget.value : "",
        storeName: this.storeName,
        location: this.location ? this.location.value : "",
        storeType: this.storeType ? this.storeType.value : "",
        storeCount:
          this.activeTab === 0 && this.storeCount
            ? Number(this.storeCount)
            : "",
        type: this.activeTab,
        regionCode: this.phoneRegionCode,
      };
      const res = await this.$axios.post(
        "/user/system/v1/enrollProspectivePartner",
        params,
        { headers: { source: 14 } } // source: 14 代表PC端
      );
      if (res.success === true || res.data) {
        this.$message.success(this.$t("home_partner_success_submit"));
        this.clearForm();
      } else {
        this.$message.error(
          res.data?.msg || this.$t("home_partner_success_error")
        );
      }
    },
    fetchPartnerOptions() {
      this.fetchRegionCodeList();
      this.fetchBudgetOptions();
      this.fetchStoreTypeOptions();
      this.fetchStoreLocationOptions();
    },
    syncSelectedOption(field, options, key) {
      const selected = this[field];
      if (!selected) return;
      const matched = options.find((item) => item[key] === selected[key]);
      this[field] = matched || null;
    },
    async fetchRegionCodeList() {
      const res = await this.$axios.get(
        "/user/system/v1/queryRegionCodeListForPartner"
      );
      if (
        res.data &&
        res.data.data &&
        Array.isArray(res.data.data) &&
        res.data.data.length > 0
      ) {
        this.phonePrefixList = res.data.data
          .reduce((list, group) => list.concat(group.data), [])
          .map((item) => ({ code: item.code }));
      }
    },
    // 投资预算选项
    async fetchBudgetOptions() {
      const res = await this.$axios.get(
        "/user/system/v1/queryBudgetOptions"
      );
      if (res.data && Array.isArray(res.data.data)) {
        this.budgetOptions = res.data.data.map((item) => ({
          id: item.id,
          value: item.value,
          label: item.value,
        }));
        this.syncSelectedOption("budget", this.budgetOptions, "id");
      }
    },
    // 店铺类型选项
    async fetchStoreTypeOptions() {
      const res = await this.$axios.get(
        "/user/system/v1/queryProspectivePartnerStoreType"
      );
      if (res.data && res.data.data) {
        this.storeTypeOptions = Object.keys(res.data.data).map((key) => ({
          value: Number(key),
          label: res.data.data[key],
        }));
        this.syncSelectedOption("storeType", this.storeTypeOptions, "value");
      }
    },
    // 店铺位置选项：接口按地区分组返回，当前网站仅服务香港，直接取第一个分组的子级选项
    async fetchStoreLocationOptions() {
      const res = await this.$axios.get(
        "/user/system/v1/queryProspectiveParentRegionOptions"
      );
      if (res.data && Array.isArray(res.data.data)) {
        const currentArea = res.data.data[0];
        if (currentArea && Array.isArray(currentArea.children)) {
          this.locationOptions = currentArea.children.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          this.syncSelectedOption("location", this.locationOptions, "value");
        }
      }
    },
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    clientTag() {
      return getClientTag(this.country);
    },
    // 微信號/WhatsApp 标题固定分两行展示：第一行「微信號/」，第二行「WhatsApp」
    whatsappLabelLine1() {
      const label = this.$t("home_partner_label_whatsapp");
      const slashIndex = label.indexOf("/");
      return slashIndex > -1 ? label.slice(0, slashIndex + 1) : label;
    },
    whatsappLabelLine2() {
      const label = this.$t("home_partner_label_whatsapp");
      const slashIndex = label.indexOf("/");
      return slashIndex > -1 ? label.slice(slashIndex + 1) : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
#partner {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #ffffff;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    .top_box_l {
      color: #111111;
      width: 430.5px;
      min-width: 431px;
      .top_title {
        height: 100px;
        font-weight: 900;
        font-size: 1.3rem;
        line-height: 50px;
        font-family: $title-font;
      }
      .top_desc_title {
        margin-top: 40px;
        margin-bottom: 15px;
        font-weight: 700;
        font-size: $font-size-small;
        font-family: $content-font;
      }
      .top_desc {
        font-weight: 400;
        font-size: $font-size-mini;
        color: #999999;
        line-height: 28px;
        font-family: $content-font;
      }
    }
    .top_tabs {
      box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.08);
      margin-left: 100px;
      border-radius: 20px;

      .top_tabs_t {
        margin-bottom: 45px;
        margin-top: 26.5px;
        padding: 0 51px;
        display: flex;
        text-align: center;
        font-weight: 600;
        font-size: $font-size-base;
        line-height: 46px;
        font-family: $content-font;

        .tab-item {
          width: 50%;
          text-align: center;
          cursor: pointer;
          padding-bottom: 25px;
          color: #111111;
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 32px;
          line-height: 46px;
          text-align: center;

          &.tab-active {
            border-bottom: 2px #000000 solid;
          }

          &.tab-inactive {
            border-bottom: 1px #d8d8d8 solid;
          }
        }
      }

      .top_content {
        padding: 0 40px;
        font-size: $font-size-mini;
        font-family: $content-font;

        .top_content_r {
          width: 672.5px;
        }

        .div_input {
          box-sizing: border-box;
          width: 100%;
          height: 72px;
          line-height: 36px;
          padding: 18px 20px;
          margin-bottom: 20px;
          border-radius: 12px;
          border: 1px solid #cccccc;
          background: #FFFFFF;
          color: #111925;
          font: inherit;
          overflow: hidden;
          white-space: nowrap;

          &::placeholder {
            color: #999;
            opacity: 1;
          }

          &:focus,
          &:focus-visible {
            border-color: #000;
            outline: none;
          }

          &.div_input-error {
            border: 0.5px solid #ff7700;
          }
        }

        .field-error {
          margin-top: -14px;
          margin-bottom: 20px;
          font-weight: 400;
          color: #ff7700;
          font-family: "PingFang SC";
          font-size: 19px;
          line-height: 31px;
          text-align: left;
        }

        // 商家tab表单项：标题 + 控件，左右布局
        // label 通过固定高度 + flex 居中，与控件本身（输入框/选项行）保持垂直居中对齐，
        // 不受下方错误提示是否出现而产生的高度变化影响
        .form-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;

          .form-label {
            flex: 0 0 114px;
            width: 114px;
            height: 72px;
            margin-right: 20px;
            display: flex;
            align-items: center;
            font-weight: 400;
            color: rgba(17, 25, 37, 0.647);
            font-family: "PingFang SC";
            font-size: 22px;
            line-height: 32px;
            text-align: left;
            white-space: normal;
            word-break: break-word;

            .required {
              margin-left: 4px;
              color: #ff4d4f;
            }
          }

          // 微信號/WhatsApp 标题需固定分两行展示，覆盖 form-label 默认的横向 flex 布局
          .form-label-multiline {
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
          }

          .form-control {
            flex: 0 0 550px;
            width: 550px;
          }

          .div_input {
            margin-bottom: 0;
          }

          .select-control {
            margin-bottom: 0;
          }

          .field-error {
            margin-top: 8px;
            margin-bottom: 0;
          }
        }

        // 联系方式 / 投资预算：内容为多行（单选 + 手机号/邮箱输入框，或单选 + 错误提示），
        // 第一行（单选）高度为 56px，label 固定该高度并垂直居中，与第一行选项对齐
        .form-item-contact {
          .form-label {
            height: 56px;
          }
        }

        .form-item-budget {
          .form-label {
            align-items: flex-start;
            height: auto;
            min-height: 56px;
          }

          .budget-radio {
            align-items: flex-start;
          }
        }

        .form-item-name {
          margin-bottom: 5px;
        }

        // 联系方式单选（电话/邮箱）
        .contact-type-radio {
          display: flex;
          align-items: center;
          gap: 32px;
          height: 56px;
          margin-bottom: 5px;
          user-select: none;
          outline: none;

          .radio-option {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            font-size: $font-size-mini;
            user-select: none;
            outline: none;
            -webkit-tap-highlight-color: transparent;

            * {
              cursor: pointer;
              user-select: none;
              outline: none;
            }

            .radio-dot {
              display: inline-block;
              width: 25px;
              height: 25px;
              border-radius: 50%;
              background: #FFFFFF;
              border: 1.56px solid #11192526;
              position: relative;

              &.radio-dot-active {
                border: none;
                background: #ffdd00;

                &:after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background: #000000;
                  transform: translate(-50%, -50%);
                }
              }
            }
          }
        }

        // 投资预算单选（小於5萬 / 5-15萬 / 15-50萬 / 大於50萬），可换行
        .budget-radio {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          row-gap: 16px;
          column-gap: 32px;
          min-height: 56px;
          user-select: none;
          outline: none;

          .radio-option {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            font-size: $font-size-mini;
            white-space: nowrap;
            user-select: none;
            outline: none;
            -webkit-tap-highlight-color: transparent;

            * {
              cursor: pointer;
              user-select: none;
              outline: none;
            }

            .radio-dot {
              display: inline-block;
              width: 25px;
              height: 25px;
              border-radius: 50%;
              border: 1px solid #cccccc;
              position: relative;

              &.radio-dot-active {
                border: none;
                background: #ffdd00;

                &:after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background: #000000;
                  transform: translate(-50%, -50%);
                }
              }
            }

            .radio-label {
              font-weight: 400;
              color: #111925;
              font-family: "PingFang SC";
              font-size: 22px;
              line-height: 32px;
              text-align: left;
              cursor: pointer;
            }
          }
        }

        // 店铺位置下拉选择
        .select-control {
          box-sizing: border-box;
          // width: 550px;
          height: 72px;
          position: relative;
          padding: 18px 20px;
          border-radius: 12px;
          border: 1px solid #cccccc;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          .placeholder {
            color: #999999;
          }

          .select-arrow {
            display: inline-flex;
            align-items: center;

            img {
              width: 34px;
              height: 34px;
            }
          }

          &.select-control-error {
            border: 0.5px solid #ff7700;
          }

          .select-options {
            position: absolute;
            top: 110%;
            left: 0;
            right: 0;
            max-height: 240px;
            overflow-y: auto;
            border-radius: 12px;
            background: #FFFFFF;
            box-shadow: 0px 6.28px 18.84px 0px #00000019;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: center;
            padding: 6px;
            margin: 0;
            list-style: none;
            z-index: 10;

            li {
              box-sizing: border-box;
              width: 100%;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              flex-wrap: nowrap;
              justify-content: center;
              padding: 10px 12px 10px 12px;
              cursor: pointer;

              &:hover {
                border-radius: 8px;
                background: #1119250C;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: center;
                // padding: 6px 6px 0px 6px;
              }

              &.active {
                font-weight: 600;
              }
            }
          }
        }

        .button {

          color: #111111;
          font-weight: 500;
          font-size: 24px;
          line-height: 34px;
          box-sizing: border-box;
          height: 72px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 12px;
          text-align: center;
          background: linear-gradient(96deg, #ffe74d 0%, #ffdd00 100%);
          margin-top: 30px;
          margin-bottom: 40px;
          font-family: $content-font;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: linear-gradient(
              96deg,
              rgba(255, 231, 77, 0.8) 0%,
              rgba(255, 221, 0, 0.8) 100%
            );
          }
        }
      }
    }
  }
}
</style>
